export default __webpack_public_path__ + "static/media/purples-logo.c9f66674.jpg";